import { MobXProviderContext } from 'mobx-react'
import { useContext } from 'react'
import { State } from './types';

export const useStores = () => {
  return useContext<State>(MobXProviderContext as any);
}